import { PermissionTags } from "../permission-tags";
import { ROLE_SUMMARY_TITLE } from "./role-summary.constants";
import styles from "./role-summary.module.scss";
import type { RoleSummaryProps } from "./types-role-summary";

/** Código, nome e permissões em tags do perfil selecionado (Figma 4663:284395). */
export function RoleSummaryView({ role, testId }: RoleSummaryProps) {
  return (
    <section className={styles.summary} data-testid={testId}>
      <h3 className={styles.title}>{ROLE_SUMMARY_TITLE}</h3>

      <dl className={styles.list}>
        <div className={styles.row}>
          <dt className={styles.label}>Código:</dt>
          <dd className={styles.value}>{role.codigo}</dd>
        </div>

        <div className={styles.row}>
          <dt className={styles.label}>Nome:</dt>
          <dd className={styles.value}>{role.nome}</dd>
        </div>

        <div className={styles.row}>
          <dt className={styles.label}>Permissões:</dt>
          <dd className={styles.value}>
            <PermissionTags permissions={role.permissoes} />
          </dd>
        </div>
      </dl>
    </section>
  );
}
